import * as React from 'react';

const SvgProteinIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    id="protein-icon-32x32_svg__Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    width={32}
    height={32}
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.protein-icon-32x32_svg__st0{fill:#e72623}'}</style>
    <path d="M22.667 21.25h-1.301c0-2.133-1.734-3.867-3.867-3.867s-3.868 1.734-3.868 3.867h-1.3c0-2.85 2.318-5.167 5.167-5.167s5.169 2.317 5.169 5.167z" />
    <path d="M13.631 21.79h-1.3c0-2.769-2.252-5.021-5.021-5.021s-5.022 2.253-5.022 5.021h-1.3c0-3.485 2.836-6.321 6.322-6.321s6.321 2.836 6.321 6.321zM22.264 19.396l-1.301-.02c.005-.326.117-7.755.511-10.826a6.71 6.71 0 0 1-.203-.23l-1.52.546a.66.66 0 0 1-.475-.014l-3.348-1.428a.648.648 0 0 1-.333-.874l.81-1.722 1.176.554-.522 1.111 2.493 1.064 1.718-.617a.648.648 0 0 1 .741.225c.133.178.406.515.573.657a.65.65 0 0 1 .221.593c-.417 2.737-.54 10.899-.541 10.981z" />
    <path d="M18.649 27.746c-3.56 0-5.482-1.446-5.569-1.514l.793-1.029c.017.013 1.996 1.464 5.644 1.212 1.022-.072 2.306-.698 3.664-1.361 1.71-.835 3.636-1.775 5.513-1.795 1.992-2.48.567-8.597-.175-10.806-.529-1.573-3.176-6.805-3.74-7.915L17.93 1.572l-1.69 2.473 2.2.907.487-.917 1.148.61-.765 1.438a.65.65 0 0 1-.822.296l-3.486-1.438a.65.65 0 0 1-.289-.968L17.16.395a.649.649 0 0 1 .795-.23l7.555 3.272c.138.06.251.167.319.3.135.263 3.301 6.455 3.922 8.3.122.364 2.957 8.955-.302 12.327a.707.707 0 0 1-.498.197c-1.65-.068-3.452.805-5.2 1.658-1.476.72-2.869 1.4-4.143 1.49-.332.026-.651.037-.959.037z" />
    <path d="M11.956 29.476c-1.613 0-3.385-.47-5.064-1.881l.837-.996c4.207 3.538 9.046.119 9.25-.028l.763 1.053c-.038.026-2.605 1.852-5.786 1.852z" />
    <path d="M5.869 31.927h-1.3v-2.814c0-.158.058-.312.163-.431l3.456-3.914.975.861-3.293 3.729v2.569z" />
    <path className="protein-icon-32x32_svg__st0" d="M16.306 13.199h1.3v2.051h-1.3z" />
    <path
      transform="rotate(-26.137 14.218 14.834)"
      className="protein-icon-32x32_svg__st0"
      d="M13.568 13.827h1.3v2.013h-1.3z"
    />
    <path
      transform="rotate(-61.933 19.654 14.833)"
      className="protein-icon-32x32_svg__st0"
      d="M18.631 14.184h2.048v1.299h-2.048z"
    />
  </svg>
);

export default SvgProteinIcon;
